import { render, staticRenderFns } from "./TemplateGalleryHtmlCard.vue?vue&type=template&id=32aa4ea4&scoped=true"
import script from "./TemplateGalleryHtmlCard.vue?vue&type=script&lang=js"
export * from "./TemplateGalleryHtmlCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateGalleryHtmlCard.vue?vue&type=style&index=0&id=32aa4ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa4ea4",
  null
  
)

export default component.exports